import type {
  SupportTicketStatus,
  SupportTicketType,
} from '@travel-planner/shared/schemas';
import { Badge } from '@/shared/ui';

const humanize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, ' ');

// Status → shared Badge variant (matches the app's semantic colours):
// open = amber (needs attention), in_progress = green (being worked),
// resolved = teal (done), closed = grey (archived), cancelled = red (voided).
const STATUS_VARIANT: Record<
  SupportTicketStatus,
  'pending' | 'active' | 'delivered' | 'inactive' | 'error'
> = {
  open: 'pending',
  in_progress: 'active',
  resolved: 'delivered',
  closed: 'inactive',
  cancelled: 'error',
};

export const SupportStatusBadge = ({
  status,
}: {
  status: SupportTicketStatus;
}) => (
  <Badge dot variant={STATUS_VARIANT[status]}>
    {humanize(status)}
  </Badge>
);

// Type → shared Badge variant (category colour, not urgency): bug = red
// (defect), ui_issue = amber (visual defect, lower severity than a bug),
// question = blue (informational), support_request = green (actionable
// ask), other = grey (catch-all).
const TYPE_VARIANT: Record<
  SupportTicketType,
  'error' | 'medium' | 'booked' | 'active' | 'inactive'
> = {
  bug: 'error',
  ui_issue: 'medium',
  question: 'booked',
  support_request: 'active',
  other: 'inactive',
};

export const SupportTypeBadge = ({ type }: { type: SupportTicketType }) => (
  <Badge variant={TYPE_VARIANT[type]}>{humanize(type)}</Badge>
);
